import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";

/**
 * WordPress dependencies
 */
import { Component } from '@wordpress/element';
/**
 * Internal dependencies
 */

import withFocusOutside from '../higher-order/with-focus-outside';

var PopoverDetectOutside =
/*#__PURE__*/
function (_Component) {
  _inherits(PopoverDetectOutside, _Component);

  function PopoverDetectOutside() {
    _classCallCheck(this, PopoverDetectOutside);

    return _possibleConstructorReturn(this, _getPrototypeOf(PopoverDetectOutside).apply(this, arguments));
  }

  _createClass(PopoverDetectOutside, [{
    key: "handleFocusOutside",
    value: function handleFocusOutside(event) {
      this.props.onFocusOutside(event);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return PopoverDetectOutside;
}(Component);

export default withFocusOutside(PopoverDetectOutside);
//# sourceMappingURL=detect-outside.js.map